module.exports = __webpack_public_path__ + "img/csj_banner.137b056.png";